<template>
    <v-container>
        <v-lov-dialog title="选择父节点" :width="800"
                      :fields="menuLovFields"
                      query-api="MENU_QUERY"
                      v-model="showMenuLovDialog"
                      @cancel="showMenuLovDialog=false"
                      @ok="onSelectParent"></v-lov-dialog>
        <v-lov-dialog title="选择权限组" :width="800"
                      :fields="permissionLovFields"
                      query-api="PERMISSION_QUERY"
                      v-model="showPermissionLovDialog"
                      @cancel="showPermissionLovDialog=false"
                      @ok="onSelectPermission"></v-lov-dialog>
        <v-icon-selector-dialog v-model="showIconDialog" @ok="onSelectIcon"></v-icon-selector-dialog>
        <v-simple-form title="用户信息">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                    <v-icon color="gray">mdi-step-backward</v-icon>
                    返回
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                    <v-icon color="gray">mdi-content-save</v-icon>
                    保存
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-form-field x-large v-model="dataItem.nodeName" label="显示名称"></v-form-field>
                <v-form-field x-large v-model="dataItem.icon" label="图标">
                    <template v-slot:content v-if="dataItem.icon">
                        <v-btn @click="showIconDialog=true" icon>
                            <v-icon>{{dataItem.icon}}</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:content v-else>
                        <v-btn @click="showIconDialog=true" tile color="primary" text small>
                            选择图标
                        </v-btn>
                    </template>
                </v-form-field>
                <v-form-field disable x-large v-model="dataItem.parentName" label="父节点">
                    <template v-slot:append>
                        <v-btn icon small @click="showMenuLovDialog=true">
                            <v-icon>mdi-database-search</v-icon>
                        </v-btn>
                        <v-checkbox @change="onSelectRoot" class="ml-3" hide-details dense></v-checkbox>
                        父节点为根路径
                    </template>
                </v-form-field>
                <v-form-field disable x-large v-model="dataItem.path" label="路径"></v-form-field>
                <v-form-selector x-large v-model="dataItem.targetType" label="目标"
                                 items="组件|component,URL|url"></v-form-selector>
                <v-form-field x-large v-model="dataItem.target" label="路由"></v-form-field>
                <v-form-field x-large v-model="dataItem.permissionName" label="权限组">
                    <template v-slot:append>
                        <v-btn icon small @click="showPermissionLovDialog=true">
                            <v-icon>mdi-database-search</v-icon>
                        </v-btn>
                    </template>
                </v-form-field>
            </template>
        </v-simple-form>
    </v-container>
</template>

<script>

    import MenuLovFields from "./fields/FndMenuLovFields"
    import PermissionLovFields from "./fields/FndPermissionLov";

    export default {
        name: "FndMenuDetail.vue",
        data() {
            return {
                docId: null,
                menuLovFields: MenuLovFields,
                permissionLovFields: PermissionLovFields,
                showIconDialog: false,
                showMenuLovDialog: false,
                showPermissionLovDialog: false,
                parent: null,
                dataItem: {
                    id: null,
                    nodeName: null,
                    icon: null,
                    path: null,
                    parentId: null,
                    parentName: null,
                    targetType: null,
                    target: null,
                    permissionName: null,
                    permissionId: null
                }
            }
        },
        created() {
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                if (this.parent) {
                    if (this.parent.path == "/") {
                        this.dataItem.path = this.parent.path + this.dataItem.nodeName;
                    } else {
                        this.dataItem.path = this.parent.path + "/" + this.dataItem.nodeName;
                    }
                }
                this.$request
                    .request("MENU_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                    });
            },
            onSelectIcon(icon) {
                this.dataItem.icon = icon;
                this.showIconDialog = false;
            },

            queryDetail(id) {
                this.$request
                    .request("MENU_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data)
                    });
            },
            onSelectParent(item) {
                this.parent = item;
                this.dataItem.parentName = item.nodeName;
                this.dataItem.parentId = item.id;
                this.dataItem.path = item.path;
                this.showMenuLovDialog = false;
            },
            onSelectRoot(val) {
                if (val) {
                    this.parent = {
                        path: "/",
                        nodeName: "/"
                    }
                    this.dataItem.parentName = "/"
                    this.dataItem.path = "/";
                } else {
                    this.parent = null;
                    this.dataItem.parentName = undefined;
                    this.dataItem.path = undefined;
                    this.dataItem.parentId = undefined;
                }
            },
            onSelectPermission(val) {
                // console.log(val.name);
                this.dataItem.permissionId = val.id;
                this.dataItem.permissionName = val.name;
                this.showPermissionLovDialog = false;
                console.log(this.data.dataItem)
            }
        }
    }
</script>
